document.querySelectorAll('.product-faq').forEach(function (section) {
  var items = section.querySelectorAll('.product-faq__item');

  items.forEach(function (item, index) {
    var trigger = item.querySelector('.product-faq__trigger');
    var content = item.querySelector('.product-faq__content');

    if (index === 0) {
      item.classList.add('product-faq__item--open');
      trigger.setAttribute('aria-expanded', 'true');
      content.style.height = content.scrollHeight + 'px';
    }

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('product-faq__item--open');

      items.forEach(function (other) {
        other.classList.remove('product-faq__item--open');
        other.querySelector('.product-faq__trigger').setAttribute('aria-expanded', 'false');
        other.querySelector('.product-faq__content').style.height = '0px';
      });

      if (!isOpen) {
        item.classList.add('product-faq__item--open');
        trigger.setAttribute('aria-expanded', 'true');
        content.style.height = content.scrollHeight + 'px';
      }
    });
  });
});
